/* eslint-disable react/prop-types */

import React from "react";
import { PropTypes } from "prop-types";
import { graphql, Link } from "gatsby";
import Button from "~components/Button";
import CaseStudies from "~components/CaseStudies";
import Clients from "~components/Clients";
import Layout from "~components/Layout";
import SEO from "~components/SEO";
import { splitStringToParagraphs } from "~utils/helpers";

const WorkPage = ({ data, location }) => {
  const { frontmatter } = data.markdownRemark;

  //

  const caseStudies = [];

  data.allMarkdownRemark.edges.forEach(caseStudy => {
    caseStudies.push(caseStudy);
  });

  caseStudies.sort((a, b) => {
    const titleA = a.node.frontmatter.title;
    const titleB = b.node.frontmatter.title;

    if (titleA < titleB) {
      return -1;
    }

    if (titleA > titleB) {
      return 1;
    }

    return 0;
  });

  return (
    <>
      <SEO
        customTitle={frontmatter.title}
        customDescription={frontmatter.seoDescription}
        customKeywords={frontmatter.seoKeywords}
        path={location.pathname}
      />

      <Layout className="work-page w-full relative bg-white text-orange">
        <section className="bg-sauvignon xs:pt-14">
          <CaseStudies caseStudies={caseStudies} />
        </section>

        <section className="animation-appear-down animation-delay-2 grid pt-v7 xs:pt-14">
          {splitStringToParagraphs(
            frontmatter.introText,
            `grid-end-6 xs:grid-end-8 universal-sans b1`
          )}
        </section>

        <section className="pt-v7 xs:pt-v14">
          <Clients clients={frontmatter.clients} />
        </section>

        <section className="w-full relative mt-v7 xs:mt-v28 mb-v7 xs:mb-v28">
          <div className="grid">
            <div className="grid-end-12 xs:grid-end-8 flex justify-center">
              <Link to="/process">
                <Button
                  className=""
                  color="orange"
                  filled
                  text="See our Process"
                />
              </Link>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

WorkPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.shape({})
    })
  }).isRequired,
  location: PropTypes.shape({}).isRequired
};

export default WorkPage;

export const query = graphql`
  query WorkPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        heading
        introText
        clients {
          name
          link
        }
        seoDescription
        seoKeywords
      }
    }
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "case-study-page" } } }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            tagline
            priority
            workpage
            industry
            tone
            heading
            imageAspect
            bannerBackground
            bannerFont
            bannerFontColor
          }
        }
      }
    }
  }
`;
